export const initialState = () => ({
  company: {
    id: null,
    name: null,
    isOwner: null,
    facilitiesCount: null
  },
  member: {
    id: null,
    isActive: false,
    email: null,
    type: 3,
    permissionType: null,
    allFacilitiesAccess: false,
    facilitiesIds: [],
    facilitiesGroupsIds: [],
    facilitiesAccessCount: 0,
    facilitiesGroupsAccessCount: 0,
    permissions: {
      viewDashboard: true,
      viewFacilitiesData: true,
      viewGmbInsights: false,
      viewMapsRankings: false,
      viewMapsCompetitionRankings: false,
      viewCompanyData: true,
      viewLocalPosts: false,
      viewReviewsAnalytics: false,
      viewReviews: false,
      viewTeam: false,
      viewExternalChanges: false,
      viewExternalChangesHistory: false,
      protectFromExternalChanges: false,
      approveAndRejectExternalChanges: false,
      editFacilityName: false,
      editFacilityAddress: false,
      editFacilityHours: false,
      editFacilityWebsite: false,
      editFacilityPhoneNumber: false,
      editFacilityStoreCode: false,
      editFacilityDescription: false,
      editFacilityLabels: false,
      editFacilityOpenStatus: false,
      editFacilityOpeningDate: false,
      editFacilityAttributes: false,
      editFacilityServiceItems: false,
      editFacilityPrimaryCategory: false,
      editFacilityAdditionalCategories: false,
      editReviewReplyTemplates: false,
      manageCompetitionPlaces: false,
      manageKeywords: false,
      manageGmbAccount: false,
      manageExternalGmbAddresses: false,
      manageTeam: false,
      manageCompanyData: false,
      manageReviewsCategories: false,
      assignReviewsCategories: false,
      addAndDeleteLocalPosts: false,
      replyReviews: false,
      manageStoreLocator: false,
      addAndDeletePhotos: false,
      viewPhotos: false,
      viewRbReviews: false,
      configureAiReviewReply: false
    }
  },
  activeDialog: null,
  mode: null
});

export default initialState();
